import { Usuario } from './../../model/usuario';
import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { AutenticacaoResult, UserResult } from '../auth/jwt-model';

@Injectable()
export class JwtService {

  constructor() { }

  hasToken() {
    return !!this.getToken();
  }

  getToken(): any {
    return  window.localStorage.getItem('TokenAcesso');
  }

  getTokenDados(): any {
    return  window.localStorage.getItem('Token');
  }

  getUsuarioDados(): any {
    return  window.localStorage.getItem('UsuarioLogado');
  }

  getUsuarioDadosJSON() {
    var usuario = JSON.parse(this.getUsuarioDados());
    return  usuario;
  }

  getUsuarioNomeCpf(): any {
    var usuario = JSON.parse(this.getUsuarioDados());
    var usuario_returno = "Id: " + usuario.Id + " - Cpf: " + usuario.Cpf + " - Nome: " + usuario.Nome;
    return usuario_returno ;
  }

  getDescricaoEntidade(): any {

    var usuario = JSON.parse(this.getUsuarioDados());
    var usuario_returno = usuario.DescricaoEntidade;
    return usuario_returno ;
  }

  getImagemEntidade(): any {

    var usuario = JSON.parse(this.getUsuarioDados());
    var usuario_returno = (usuario.ImagemEntidade == "" ? "assets/images/cecam_logo.png" : usuario.ImagemEntidade);
    return usuario_returno ;
  }
  getImagemUsuario(): any {

    var usuario = JSON.parse(this.getUsuarioDados());
    var usuario_returno = (usuario.ImagemUsuario == "" ? "assets/images/users/user.jpg" : usuario.ImagemUsuario);
    return usuario_returno ;
  }

  destroyToken() {
    window.localStorage.removeItem('TokenAcesso');
    window.localStorage.removeItem('Token');
    window.localStorage.removeItem('UsuarioLogado')
  }

  isExpiredFromToken(token: string): any {
    if (!token) {
      return null;
    }

    let decoded: any;

    try {
      decoded = jwt_decode(token);
    } catch (error) {
      decoded = null;
    }

    const jwt: AutenticacaoResult = <AutenticacaoResult>decoded;
    const date = new Date(0);

    if (jwt) { date.setUTCSeconds(parseInt(jwt.exp)); }

    if (date == null) {
      return null;
    }

    return !(date.valueOf() > (new Date().valueOf()));
  }

  isExpired(): any {
    const token = this.getToken();
    if (!token) {
      return null;
    }

    const date = this.getTokenExpirationDate(token);

    if (date == null) {
      return null;
    }

    return !(date.valueOf() > (new Date().valueOf()));
  }

  public getEmailFromToken(token: string): string {
    if (!token) {
      return "";
    }

    let decoded: any;

    try {
      decoded = jwt_decode(token);
    } catch (error) {
      decoded = null;
    }

    const jwt: AutenticacaoResult = <AutenticacaoResult>decoded;

    return jwt.email;
  }

  public getTokenExpirationDate(token: string): Date {
    const jwt = this.getJwt();
    const date = new Date(0);

    if (jwt) { date.setUTCSeconds(parseInt(jwt.exp)); }

    return date;
  }

  obterUserData(): UserResult | null {
    let value = window.localStorage.getItem('UserData') ?? '';

    if (value)
      return JSON.parse(value);

    return null;
  }

  getJwt() {
    const token = this.getToken();
    if (!token) {
      return null;
    }

    let decoded: any;

    try {
      decoded = jwt_decode(token);
    } catch (error) {
      decoded = null;
    }

    const jwt: AutenticacaoResult = <AutenticacaoResult>decoded;

    return jwt;
  }
}
